import React, { useState, useRef, useEffect } from 'react';
import styled from "styled-components";
import { getOrderNoByGoodId, getOrderRaw, getPayBillStatus } from '../../api/api'
import { message } from 'antd';
import QRCode from 'qrcode';
import _ from 'lodash';

const CurriculumSeries = props => {
  const [phone, setPhone] = useState('');
  const [showQRCode, setShowQRCode] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [qrCodeImage, setQrCodeImage] = useState('');
  const [loading, setLoading] = useState(false);
  const searchTimer = useRef(null);
  const courseImages = [
    'https://cdn.quthing.com/a30e0de6-1444-4427-8ffb-a6b3bf6b8d90',
    'https://cdn.quthing.com/3b053976-3dab-4bef-9da8-2b79dbfb38fd',
    'https://cdn.quthing.com/36be3eb1-24b8-42d2-b33d-2ca0e98f7054',
    'https://cdn.quthing.com/63531aa1-8d87-4d64-b3d9-1caa12c447f2'
  ];

  const courseFeatures = [
    { icon: '📚', title: '系统化课程体系', desc: '从基础到进阶，科学的学习路径设计' },
    { icon: '🎯', title: '实战项目驱动', desc: '通过真实项目掌握核心技能' },
    { icon: '👨‍🏫', title: '老师一对一指导', desc: '在线答疑，个性化辅导' },
    { icon: '🤖', title: 'AI学习分析', desc: '智能互动，实时纠正错误' }
  ];
  // useEffect(() => {
  //   message.error({
  //     content: '请输入正确的手机号',
  //     duration: 2,
  //     style: {
  //       marginTop: '40px',
  //     }
  //   });
  // }, [])
  const handlePay = async () => {
    if (!phone || phone.length !== 11 || !/^1[3-9]\d{9}$/.test(phone)) {
      message.error({
        content: '请输入正确的手机号',
        duration: 2,
        style: {
          marginTop: '40px',
        }
      });
      return;
    }
    setLoading(true);
    // 这里应该是获取真实二维码的逻辑
    const res = await getOrderNoByGoodId({
      // 测试piano_android_basic_course_v2
      goodsId: 'piano_android_basic_course',
      amount: 1,
      origin: 'quthing_web',
      businessExtra: {
        mobile: phone,
        app_package: "piano_android"
      }
    })
    if (!res.error) {
      const _orderNo = _.get(res, 'data.orderNo', '')
      const result = await getOrderRaw({ payChannel: 'wxpay_native', orderNo: _orderNo });
      const _url = await QRCode.toDataURL(_.get(result, 'data.codeUrl'));
      if (_url) {
        setShowQRCode(true);
        setQrCodeImage(_url);
        onSearchStatus(_orderNo);
        setLoading(false)
      }
      setLoading(false)
    }
  };
  const onSearchStatus = (orderNoParam) => {
    searchTimer.current = setInterval(() => {
      getStatus(orderNoParam);
    }, 1000);
  }
  const getStatus = async (orderNoParam) => {
    const res = await getPayBillStatus(orderNoParam);
    const _status = res.data.success || false;
    if (_status) {
      clearInterval(searchTimer.current);
      searchTimer.current = null;
      message.success({
        content: '支付成功',
        duration: 5,
        style: {
          marginTop: '40px',
        }
      });
      setPhone('')
      setShowQRCode(false);
    }
  };
  const handleImageNav = (direction) => {
    let newIndex = currentImageIndex;
    if (direction === 'prev') {
      newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : courseImages.length - 1;
    } else {
      newIndex = currentImageIndex < courseImages.length - 1 ? currentImageIndex + 1 : 0;
    }
    setCurrentImageIndex(newIndex);
  };

  return (
    <Wrapper>
      {/* 顶部：课程标题和简介 */}
      <Header>
        <h1>精品系列课程</h1>
        <p>专业导师指导，系统化学习路径，从入门到精通</p>
      </Header>

      {/* 主内容区域 */}
      <ContentWrapper>
        {/* 左侧：课程图片展示区域 */}
        <LeftSection>
          <ImageSlider>
            <MainImageContainer>
              <img
                src={courseImages[currentImageIndex]}
                alt={`课程介绍 ${currentImageIndex + 1}`}
              />
              <NavButton
                direction="prev"
                onClick={() => handleImageNav('prev')}
              >
                ‹
              </NavButton>
              <NavButton
                direction="next"
                onClick={() => handleImageNav('next')}
              >
                ›
              </NavButton>
            </MainImageContainer>

            <ImageThumbnails>
              {courseImages.map((img, index) => (
                <Thumbnail
                  key={index}
                  active={index === currentImageIndex}
                  onClick={() => setCurrentImageIndex(index)}
                >
                  <img src={img} alt={`缩略图 ${index + 1}`} />
                </Thumbnail>
              ))}
            </ImageThumbnails>

            <ImageCounter>
              {currentImageIndex + 1} / {courseImages.length}
            </ImageCounter>
          </ImageSlider>

          {/* 课程特色 */}
          <CourseFeatures>
            {courseFeatures.map((feature, index) => (
              <FeatureItem key={index}>
                <FeatureIcon>{feature.icon}</FeatureIcon>
                <FeatureText>
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </FeatureText>
              </FeatureItem>
            ))}
          </CourseFeatures>
        </LeftSection>

        {/* 右侧：固定悬浮购买面板 */}
        <RightSection>
          <PayCard>
            <PayTitle>立即购买</PayTitle>
            <PriceContainer>
              <CurrentPrice>¥ 199</CurrentPrice>
              <OriginalPrice>原价: ¥ 399</OriginalPrice>
              <DiscountBadge>限时优惠</DiscountBadge>
            </PriceContainer>
            <Divider />
            <CourseInfo>
              <InfoItem>
                <span>课程包含：</span>
                <span>21节精品视频课程</span>
              </InfoItem>
              <InfoItem>
                <span>有效期：</span>
                <span>永久有效</span>
              </InfoItem>
            </CourseInfo>

            {/* 手机号输入区域 */}
            <InputArea>
              <InputBox>
                <input
                  type="tel"
                  placeholder="请输入11位手机号"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 11))}
                  maxLength={11}
                />
                <InputTip>用于开通课程和接收学习资料</InputTip>
              </InputBox>

              <PayButton onClick={handlePay} disabled={loading}>
                {loading ? '生成二维码中...' : '确认支付 ¥199.00'}
              </PayButton>
            </InputArea>

            {/* 支付二维码区域 - 一直存在，但二维码图片在验证后才显示 */}
            <QrBox>
              {showQRCode ? (
                <>
                  <PaymentInfo>
                    <div>
                      <PaymentLabel>手机号码</PaymentLabel>
                      <PaymentValue>{phone}</PaymentValue>
                    </div>
                  </PaymentInfo>

                  <QrContent>
                    <QrTitle>扫码完成支付</QrTitle>
                    <QrImage
                      src={qrCodeImage}
                      alt="支付二维码"
                    />
                    <QrTip>请打开微信扫一扫支付</QrTip>
                  </QrContent>
                </>
              ) : (
                <QrPlaceholder>
                  <PlaceholderText>请输入手机号获取支付二维码</PlaceholderText>
                </QrPlaceholder>
              )}

              {showQRCode && (
                <CloseButton onClick={() => setShowQRCode(false)}>
                  重新填写手机号
                </CloseButton>
              )}
            </QrBox>
          </PayCard>

          {/* 额外信息 */}
          <ExtraInfo>
            <InfoCard>
              <h4>📞 联系客服</h4>
              <p>如有疑问，请联系在线客服</p>
              <p>工作时间：9:00-21:00</p>
            </InfoCard>
          </ExtraInfo>
        </RightSection>
      </ContentWrapper>
    </Wrapper>
  )
}

export default CurriculumSeries

// ================== 样式部分 ==================

// 主容器
const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  min-height: 100vh;
`;

// 头部
const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  
  h1 {
    font-size: 32px;
    margin: 0 0 10px 0;
    color: #1a1a1a;
    font-weight: 600;
  }
  
  p {
    font-size: 16px;
    color: #666;
    margin: 0;
  }
`;

// 内容区域
const ContentWrapper = styled.div`
  display: flex;
  gap: 40px;
  
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 30px;
  }
`;

// 左侧内容
const LeftSection = styled.div`
  flex: 1;
  min-width: 0; /* 防止flex元素溢出 */
`;

// 图片轮播
const ImageSlider = styled.div`
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  margin-bottom: 30px;
`;

const MainImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa; /* 添加一个背景色，当图片不占满时显示 */
  
  img {
    max-width: 65%;
    width: auto;
    height: 100%;
    object-fit: contain; 
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.02);
    }
  }
  
  @media (max-width: 768px) {
    height: 300px;
    
    img {
      max-width: 80%; /* 在小屏幕上稍微增大图片比例 */
    }
  }
`;

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  
  left: ${props => props.direction === 'prev' ? '20px' : 'auto'};
  right: ${props => props.direction === 'next' ? '20px' : 'auto'};
  
  &:hover {
    background: white;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  &:active {
    transform: translateY(-50%) scale(0.95);
  }
`;

const ImageThumbnails = styled.div`
  display: flex;
  padding: 20px;
  gap: 15px;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const Thumbnail = styled.div`
  flex: 0 0 100px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  opacity: ${props => props.active ? 1 : 0.6};
  border: 2px solid ${props => props.active ? '#4096ff' : 'transparent'};
  transition: all 0.2s;
  
  &:hover {
    opacity: 1;
    transform: translateY(-2px);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ImageCounter = styled.div`
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #666;
  background: #f8f9fa;
  border-top: 1px solid #f0f0f0;
`;

// 课程特色
const CourseFeatures = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const FeatureIcon = styled.div`
  font-size: 28px;
  line-height: 1;
`;

const FeatureText = styled.div`
  flex: 1;
  
  h4 {
    margin: 0 0 8px 0;
    font-size: 16px;
    color: #333;
  }
  
  p {
    margin: 0;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }
`;

// 右侧固定购买面板
const RightSection = styled.div`
  width: 380px;
  height: fit-content;
  
  @media (max-width: 900px) {
    width: 100%;
    position: static;
  }
`;

// 支付卡片
const PayCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  margin-bottom: 20px;
`;

const PayTitle = styled.h3`
  font-size: 20px;
  margin: 0;
  text-align: center;
  color: #333;
  font-weight: 600;
`;

const PriceContainer = styled.div`
  text-align: center;
  position: relative;
`;

const CurrentPrice = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: #ff4d4f;
  line-height: 1;
`;

const OriginalPrice = styled.div`
  font-size: 16px;
  color: #999;
  text-decoration: line-through;
  margin-top: 5px;
`;

const DiscountBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 27px;
  background: linear-gradient(135deg, #ff4d4f, #f5222d);
  color: white;
  padding: 4px 6px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  z-index: 1;
  box-shadow: 0 4px 12px rgba(245, 34, 45, 0.3);
  display: flex;
  align-items: center;
  gap: 4px;
  
  &::before {
    content: "🔥";
    font-size: 14px;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(to right, transparent, #f0f0f0, transparent);
  margin: 10px 0;
`;

const CourseInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: fadeIn 0.3s ease;
`;

const InfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  
  span:first-child {
    color: #666;
  }
  
  span:last-child {
    color: #333;
    font-weight: 500;
  }
`;

// 输入区域
const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  animation: fadeIn 0.3s ease;
`;

const InputBox = styled.div`
  input {
    width: 100%;
    height: 48px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 0 15px;
    font-size: 15px;
    outline: none;
    box-sizing: border-box;
    transition: all 0.2s;
    background: #fafafa;
    
    &:focus {
      border-color: #4096ff;
      background: white;
      box-shadow: 0 0 0 3px rgba(64, 150, 255, 0.1);
    }
    
    &::placeholder {
      color: #aaa;
    }
  }
`;

const InputTip = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  padding-left: 5px;
`;

const PayButton = styled.button`
  height: 52px;
  background: linear-gradient(135deg, #4096ff, #165dff);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 5px;
  
  &:hover {
    background: linear-gradient(135deg, #165dff, #0e42d7);
    box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

// 支付二维码区域
const QrBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 10px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
`;

const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: fadeIn 0.3s ease;
`;

const PaymentLabel = styled.div`
  font-size: 13px;
  color: #999;
  margin-bottom: 4px;
`;

const PaymentValue = styled.div`
  font-size: 16px;
  color: #333;
  font-weight: 500;
`;

const QrContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const QrTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
`;

const QrImage = styled.img`
  width: 220px;
  height: 220px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  padding: 10px;
  background: white;
`;

const QrTip = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 500;
  text-align: center;
`;

// 二维码占位符
const QrPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 220px;
  border-radius: 8px;
  border: 2px dashed #e8e8e8;
  background: #fafafa;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
`;


const PlaceholderText = styled.div`
  font-size: 14px;
  color: #999;
  line-height: 1.4;
`;

const CloseButton = styled.button`
  height: 40px;
  border: 1px solid #e8e8e8;
  background: white;
  color: #666;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  margin-top: 10px;
  
  &:hover {
    border-color: #4096ff;
    color: #4096ff;
  }
`;

// 额外信息卡片
const ExtraInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const InfoCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  
  h4 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #333;
  }
  
  p {
    margin: 5px 0;
    font-size: 14px;
    color: #666;
  }
`;